import {  Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { AanwerfSimulator } from 'src/app/models/AanwerfSimulator';
import { AanwerfSimulatorService } from "src/app/services/aanwerf-simulator.service";
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { FormBuilder, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { mergeMap, take } from 'rxjs/operators';
import { ModalContentComponent } from 'src/app/shared/modal-content/modal-content.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyPipe } from '@angular/common';
import { Onderneming } from 'src/app/models/Onderneming';

@Component({
  selector: 'app-admin-aanwerfsimulator',
  templateUrl: './admin-aanwerfsimulator.component.html',
  styleUrls: ['./admin-aanwerfsimulator.component.scss'],

})
export class AdminAanwerfsimulatorComponent implements OnInit {
  @Input() ondernemingNaam: string;
  //form variabelen
     formBuilder: IFormBuilder;
     onderneming: Onderneming;
     aanwerfFormGroup: IFormGroup<AanwerfSimulator>;

  err = [ "Dit veld is verplicht in te vullen en moet tussen 0 en 100 liggen.", "Dit veld is verplicht."];



  aanwerfSimulator: AanwerfSimulator = {
    bedrijfsVoorheffing: 0,
    extraBasisBerekeningRSZ:0,
    extraRSZWerkgever:0,
    extraForfaitPerUur:0,
    extraForfaitPerDag: 0,
    flexiRSZWerkgever:0,
    fondsHorecaPercentage:0,
    jaarlijkseVakantie:0,
    studentRSZWerkgever:0,
    studentRSZWerknemer:0,
    tekstBasisUurloon:"",
    tekstBrutoUurloon:"",
    tekstFondsHoreca:"",
    werkbonusOndergrensLuikA:0,
    werkbonusBovengrensLuikA:0,
    werkbonusFactorLuikA:0,
    werkbonusMinimumLuikA:0,
    werkbonusOndergrensLuikB:2132.59,
    werkbonusBovengrensLuikB:2723.36,
    werkbonusFactorLuikB:0.2915,
    werkbonusMinimumLuikB:172.18,
    werkbonusdagen:0,
    werknemerRSZWerkgever:0,
    id: ""
  }

  constructor(
    private aanwerfSimulatorService: AanwerfSimulatorService,
     formBuilder: FormBuilder,
    private modalService: NgbModal,
    public dataService: DataService,
    private cdref: ChangeDetectorRef


  ) {
      this.formBuilder = formBuilder
    }

  ngOnInit(): void {
     //Aanmaken van form
      this.aanwerfFormGroup = this.formBuilder.group<AanwerfSimulator>({
       studentRSZWerknemer: this.formBuilder.control(this.aanwerfSimulator.studentRSZWerknemer, [Validators.required, Validators.min(0), Validators.max(100)]),
       bedrijfsVoorheffing: this.formBuilder.control(this.aanwerfSimulator.bedrijfsVoorheffing, [Validators.required, Validators.min(0), Validators.max(100)]),
       extraRSZWerkgever: this.formBuilder.control(this.aanwerfSimulator.extraRSZWerkgever, [Validators.required, Validators.min(0), Validators.max(100)]),

       extraForfaitPerUur: this.formBuilder.control(this.aanwerfSimulator.extraForfaitPerUur, [Validators.required, Validators.min(0)]),
       extraForfaitPerDag: this.formBuilder.control(this.aanwerfSimulator.extraForfaitPerDag, [Validators.required, Validators.min(0)]),

       flexiRSZWerkgever: this.formBuilder.control(this.aanwerfSimulator.flexiRSZWerkgever, [Validators.required, Validators.min(0), Validators.max(100)]),
       fondsHorecaPercentage: this.formBuilder.control(this.aanwerfSimulator.fondsHorecaPercentage, [Validators.required, Validators.min(0), Validators.max(100)]),
       jaarlijkseVakantie: this.formBuilder.control(this.aanwerfSimulator.jaarlijkseVakantie, [Validators.required, Validators.min(0), Validators.max(100)]),
       studentRSZWerkgever: this.formBuilder.control(this.aanwerfSimulator.studentRSZWerkgever, [Validators.required, Validators.min(0), Validators.max(100)]),
       werkbonusFactorLuikA: this.formBuilder.control(this.aanwerfSimulator.werkbonusFactorLuikA, [Validators.required, Validators.min(0), Validators.max(100)]),
       werkbonusFactorLuikB: this.formBuilder.control(this.aanwerfSimulator.werkbonusFactorLuikB, [Validators.required, Validators.min(0), Validators.max(100)]),
       werknemerRSZWerkgever: this.formBuilder.control(this.aanwerfSimulator.werknemerRSZWerkgever, [Validators.required, Validators.min(0), Validators.max(100)]),
       extraBasisBerekeningRSZ: this.formBuilder.control(this.aanwerfSimulator.extraBasisBerekeningRSZ, [Validators.required, Validators.min(0)]),
       tekstBasisUurloon: this.formBuilder.control(this.aanwerfSimulator.tekstBasisUurloon, [Validators.required]),
       tekstBrutoUurloon: this.formBuilder.control(this.aanwerfSimulator.tekstBrutoUurloon, [Validators.required]),
       tekstFondsHoreca: this.formBuilder.control(this.aanwerfSimulator.tekstFondsHoreca, [Validators.required]),
       werkbonusBovengrensLuikA: this.formBuilder.control(this.aanwerfSimulator.werkbonusBovengrensLuikA, [Validators.required, Validators.min(0)]),
       werkbonusBovengrensLuikB: this.formBuilder.control(this.aanwerfSimulator.werkbonusBovengrensLuikB, [Validators.required, Validators.min(0)]),
       werkbonusdagen: this.formBuilder.control(this.aanwerfSimulator.werkbonusdagen, [Validators.required, Validators.min(0)]),
       werkbonusOndergrensLuikA: this.formBuilder.control(this.aanwerfSimulator.werkbonusOndergrensLuikA, [Validators.required, Validators.min(0)]),
       werkbonusOndergrensLuikB: this.formBuilder.control(this.aanwerfSimulator.werkbonusOndergrensLuikB, [Validators.required, Validators.min(0)]),
       werkbonusMinimumLuikA: this.formBuilder.control(this.aanwerfSimulator.werkbonusMinimumLuikA, [Validators.required, Validators.min(0)]),
       werkbonusMinimumLuikB: this.formBuilder.control(this.aanwerfSimulator.werkbonusMinimumLuikB, [Validators.required, Validators.min(0)]),

     });
    this.getData();
   
  }


  // //validation na het inladen
   ngAfterContentChecked() {
      this.cdref.detectChanges();
   }
   
  getData()
  {
    this.onderneming = this.dataService?.getOnderneming();
    this.getAanwerfSimulator(this.onderneming.aanwerfSimulator);
  
  }
  getAanwerfSimulator(id: string) {
    if (this.dataService.aanwerfSimulator == undefined) {
      this.aanwerfSimulatorService.getAanwerfSimulator(id).pipe(
        take(1))
        .subscribe(e => {
          this.aanwerfSimulator = e;
          // this.setValue();
          this.cdref.markForCheck();
        });
    }
    else
    {
      this.aanwerfSimulator = this.dataService.aanwerfSimulator;
    }
    
  }


  async onSubmit() {
    if (this.aanwerfFormGroup.invalid) {
       return;
     }
    const modalRef = this.modalService.open(ModalContentComponent);
    modalRef.componentInstance.confirmationBoxTitle = 'Bevestiging';
    modalRef.componentInstance.confirmationMessage = 'Weet u zeker dat u deze gegevens wilt opslaan?';

    const userResponse = await modalRef.result;
    if (userResponse) {
      this.opslaan();
    }
  }

  opslaan()
  {
    this.aanwerfSimulatorService.updateAanwerfSimulator(this.aanwerfSimulator);

  }
}
